import { render } from "./bookmark_folders.vue?vue&type=template&id=71d8fc6e"
import script from "./bookmark_folders.js?vue&type=script&lang=js"
export * from "./bookmark_folders.js?vue&type=script&lang=js"

import "./bookmark_folders.vue?vue&type=style&index=0&id=71d8fc6e&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__